import { ref } from "vue";
import { storeToRefs } from "pinia";
import { Trash } from "lucide-vue-next";
import { usePricerProjectsStore } from "@stores/pricer/pricerProjects";
import { useUsersStore } from "@stores/users";

export const usePricerProjectCard = () => {
  const pricerProjectsStore = usePricerProjectsStore();
  const usersStore = useUsersStore();
  const { adminSalesUsers } = storeToRefs(usersStore);
  const { deleteProject } = pricerProjectsStore;

  const pricerDropdownActions = ref([]);

  const determineRoundedValue = (value, path) => {
    if (path === "cpi") {
      if (!Number.isInteger(value)) {
        return Number(value.toFixed(2));
      } else {
        return value.toFixed(2);
      }
    } else {
      if (!Number.isInteger(value)) {
        return Math.round(value);
      } else {
        return value;
      }
    }
  };

  const determineOwner = (id) => {
    if (adminSalesUsers.value.length !== 0) {
      const sale = adminSalesUsers.value.find((sale) => sale.id === id);
      if (sale == null) return "";
      const { first_name } = sale;
      return first_name != null ? sale.first_name : sale.email;
    }
    return "";
  };

  pricerDropdownActions.value = [
    {
      isDelete: true,
      function: deleteProject,
      msgConfirm: "this project",
      text: "delete",
      icon: Trash,
    },
  ];

  return {
    determineRoundedValue,
    determineOwner,
    pricerDropdownActions,
  };
};
